import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  // Tùy chỉnh theme của bạn ở đây
  typography: {
    fontFamily: ['SVN-Outfit', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
})

export default theme 